import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataOutputModel, Opdata } from '../../models/opdata.model';
import { DataOutputModelCalc, OpdataCalc } from '../../models/opdataCalc.model';
import { Train } from '../../models/train.model';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/_service/appconfigservice';
import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';
import { RawOpdata } from 'src/app/models/opdata.model';
import { OpdataImport } from 'src/app/models/opdataCalc.model';
import { AllTrainData } from 'src/app/component/Graphs/comparasiongraph/comparasiongraph.model';
import { QueryStringParameters } from 'src/app/shared/shared.model';
@Injectable({
  providedIn: 'root',
})
export class OpdataService {
  gnBaseURL: any;
  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  
  getRawOpdataByTrainId(parameters: QueryStringParameters, id: string) {
    let params = new HttpParams();
    params = params.append('MaxPageSize', parameters.MaxPageSize);//
    params = params.append('PageNumber', parameters.PageNumber);//
    params = params.append('PageSize', parameters.PageSize);//
    params = params.append('SearchQuery', parameters.SearchQuery);
    params = params.append('OrderBy', parameters.OrderBy);
    params = params.append('OrderDir', parameters.OrderDir);
    params = params.append('SelectedValue', parameters.SelectedValue);
    return this.http.get<DataOutputModel>(
      this.gnBaseURL + 'OpdataCalc/GetRawOpdataListByTrainId?trainId=' + id,
      { params: params }
    );
  }
  getRawOpdataByTrainIdForGraph(parameters: QueryStringParameters, id: string) {
    let params = new HttpParams();
    params = params.append('MaxPageSize', 100);//
    params = params.append('PageNumber', 1);//
    params = params.append('PageSize', 10);//
    params = params.append('SearchQuery', '');
    params = params.append('OrderBy', parameters.OrderBy);
    params = params.append('OrderDir', 'desc');
    params = params.append('SelectedValue', parameters.SelectedValue);
    return this.http.get<DataOutputModel>(
      this.gnBaseURL + 'OpdataCalc/GetRawOpdataListByTrainId?trainId=' + id,
      { params: params }
    );
  }
  getCalcOpdataByTrainIdNewForGraph(parameters: QueryStringParameters, id: string) {
    let params = new HttpParams();
    params = params.append('MaxPageSize', 100);
    params = params.append('PageNumber', 1);
    params = params.append('PageSize', 10);
    params = params.append('SearchQuery','');
    params = params.append('OrderBy',' parameters.OrderBy');
    params = params.append('OrderDir', 'desc');
    params = params.append('SelectedValue', parameters.SelectedValue);

    return this.http.get<DataOutputModelCalc>(
      this.gnBaseURL + 'OpdataCalc/GetCalcOpdataListByTrainIdNew?trainId=' + id,
      { params: params }
    );
  }
  getCalcOpdataByTrainIdNew(parameters: QueryStringParameters, id: string) {
    let params = new HttpParams();
    params = params.append('MaxPageSize', parameters.MaxPageSize);
    params = params.append('PageNumber', parameters.PageNumber);
    params = params.append('PageSize', parameters.PageSize);
    params = params.append('SearchQuery', parameters.SearchQuery);
    params = params.append('OrderBy', parameters.OrderBy);
    params = params.append('OrderDir', parameters.OrderDir);
    params = params.append('SelectedValue', parameters.SelectedValue);

    return this.http.get<DataOutputModelCalc>(
      this.gnBaseURL + 'OpdataCalc/GetCalcOpdataListByTrainIdNew?trainId=' + id,
      { params: params }
    );
  }

  getCalcOpdataByTrainId(id: string) {
    return this.http.get<OpdataCalc[]>(
      this.gnBaseURL + 'OpdataCalc/GetCalcOpdataListByTrainId/' + id
    );
  }

  
  getCalcOpdataByTrainIdForWarranty(
    id: string,
    selectedWarrantyCondition: string,
    stageStr: number
  ) {
    return this.http.get<RawCalcTrainDataViewModel[]>(
      this.gnBaseURL +
        'OpdataCalc/GetCalcOpdataListByTrainIdForWarranty/' +
        id +
        '/' +
        selectedWarrantyCondition +
        '/' +
        stageStr
    );
  }

  getRawCalcOpdataByTrainId(id: string) {
    return this.http.get<RawCalcTrainDataViewModel[]>(
      this.gnBaseURL + 'OpdataCalc/GetRawCalcOpdataListByTrainId/' + id
    );
  }

  getOptimizedRawOpdataByTrainId(id: string) {
    return this.http.get<Opdata[]>(
      this.gnBaseURL + 'OpdataCalc/GetOptimisedRawOpdataListByTrainId/' + id
    );
  }
  getlargeCalcOpdataByTrainId(id: string) {
    return this.http.get<OpdataCalc[]>(
      this.gnBaseURL + 'OpdataCalc/GetOptimisedCalcOpdataListByTrainId/' + id
    );
  }

  getRefPointRawCalcOpdataListByTrainId(id: string) {
    return this.http.get<RawCalcTrainDataViewModel[]>(
      this.gnBaseURL + 'OpdataCalc/GetRefPointRawCalcOpdataListByTrainId/' + id
    );
  }

  getRawCalcOpdataByTrainIdAll(id: string) {
    return this.http.get<AllTrainData>(
      this.gnBaseURL + 'OpdataCalc/GetRawOpdataListsByTrainIdForAll/' + id
    );
  }
  
  getRawOpdataDateTime(id: string) {
    return this.http.get<Opdata[]>(
      this.gnBaseURL + 'OpdataCalc/GetRawOpdataListsForDatesByTrainId/' + id
    );
  }

  getRawOpdataFirstRowByTrainId(id: string) {
    return this.http.get<RawOpdata[]>(
      this.gnBaseURL + 'OpdataCalc/getRawOpDataByTrainId/' + id
    );
  }


  getTrainByPlantId(id: string) {
    return this.http.get<Train[]>(
      this.gnBaseURL + 'Trains/GetTrainByplantId/' + id
    );
  }
 

  exportOpdata(id: string){
    
    return this.http.get(this.gnBaseURL+ 'OpdataCalc/OPDataExport/' + id, {responseType: 'arraybuffer'});
}

  addRawOpdata(Id: number, opdataDetails) {
    const formData = new FormData();
    formData.append('model', JSON.stringify(opdataDetails));
    console.log(formData);
    return this.http.post<RawOpdata>(
      this.gnBaseURL + 'OpdataCalc/AddOpData/' + Id,
      formData
    );
  }

  editRawOpdata(opdataDetails) {
    const formData = new FormData();
    formData.append('model', JSON.stringify(opdataDetails));
    console.log(formData);
    return this.http.post<RawOpdata>(
      this.gnBaseURL + 'OpdataCalc/editOpData/',
      formData
    );
  }
  

  RecalcOpdataForNewRefPoint(id:string): Observable<Train>{
    return this.http.get<Train>(this.gnBaseURL + 'OpdataCalc/OPCalculationsForNewRefPoint/' + id);
  }


  getRawOpDataById(id: string): Observable<RawOpdata> {
    return this.http.get<RawOpdata>(this.gnBaseURL + 'OpdataCalc/getRawOpDataById/' + id);
  }

  importRawOpdata(opdataImportModel, selectedFile) {
    const formData = new FormData();
    formData.append('model', JSON.stringify(opdataImportModel));
    formData.append(selectedFile.name, selectedFile);
    console.log(formData);
    return this.http.post<OpdataImport>(
      this.gnBaseURL + 'OpdataCalc/OPDataImport',
      formData
    );
  }

  

  softDeleteModelForOpdata(Id: string, model: number[]) {
    return this.http.post<number[]>(
      this.gnBaseURL + 'OpdataCalc/' + Id + '/action/softdeleteOpdata',
      model
    );
  }

  softDeleteModelForOpdataCalc(Id: string, model: number[]) {
    return this.http.post<number[]>(
      this.gnBaseURL + 'OpdataCalc/' + Id + '/action/softdeleteOpdataCalc',
      model
    );
  }

  GetOPdatawithDflagById(id: string) {
    return this.http.get<Opdata[]>(
      this.gnBaseURL + 'OpdataCalc/GetOPdatawithDflagById/' + id
    );
  }

  GetOPdatawithIflagById(id: string) {
    return this.http.get<Opdata[]>(
      this.gnBaseURL + 'OpdataCalc/GetOPdatawithIflagById/' + id
    );
  }

  opdataUndo(id: string){
    return this.http.get(
      this.gnBaseURL + 'OpdataCalc/' + id + '/action/undo'
    );
  }

  GetOPCalcdataNew(id: string,) {
    return this.http.get<RawCalcTrainDataViewModel[]>
    (
      this.gnBaseURL + 'OpdataCalc/GetPagedOpcalcData/' + id + '%2C1%2C10000?trainId=' + id + '&page=1&pagesize=10000'
    );
  }
  GetOPCalcdataNewForComparisonGraph(id: string,) 
  {
    return this.http.get<AllTrainData>(
      this.gnBaseURL + 'OpdataCalc/GetPagedOpcalcDataForComparisonGraph/' + id + '%2C1%2C100000?trainId=' + id + '&page=1&pagesize=100000'
    );
  }

}
